import FilterEffect from "./FilterEffect";

export default FilterEffect;
